import type { Messages } from "@prop/i18n";
import type en from "../en/money";

export default {
  nav: { orders: "Pedidos", payouts: "Payouts", kyc: "Verificación", affiliate: "Afiliados" },
  chainNames: { "tron-nile": "TRON", "ethereum-sepolia": "Ethereum" },
  chains: { "tron-nile": "USDT en la red de prueba TRON Nile", "ethereum-sepolia": "USDT en la red de prueba Ethereum Sepolia" },
  buy: {
    couponHave: "¿Tienes un cupón?",
    couponChecking: "Verificando el cupón…",
    couponApplied: "Cupón −{amount}",
    couponRemove: "Quitar el cupón",
    getFree: "Obtenerlo gratis",
    freeNote: "El cupón cubre todo el precio: no hay nada que pagar. La cuenta se abre al instante.",
    methodFree: "Gratis con un código promocional",
    couponRefused: {
      coupon_invalid: "Este código no existe o ya terminó.",
      coupon_exhausted: "Este código ya se agotó.",
      coupon_used: "Ya usaste este código.",
      coupon_new_users_only: "Este código es solo para traders nuevos, en su primera compra.",
    },
    title: "Comprar un challenge",
    program: "Programa",
    coupon: "Cupón",
    apply: "Aplicar",
    method: "Método de pago",
    card: "Tarjeta",
    crypto: "Cripto",
    cardSoon: "No disponible temporalmente",
    coin: "Moneda y red",
    feeLow: "Tarifa de red baja",
    feeHigh: "Tarifa de red más alta (gas)",
    rate: "1 {coin} ≈ {usd}",
    noCrypto: "Los pagos con cripto no están disponibles por un momento. Inténtalo de nuevo en unos minutos.",
    youGet: "Lo que recibes",
    account: "Cuenta {program} de {size}",
    offer: "Bono de esta compra",
    youSave: "Ahorras {amount}",
    trust: {
      instant: "La cuenta se abre sola en cuanto se confirma el pago",
      rules: "Las reglas de esta cuenta son fijas: las que ves aquí",
      split: "Reparto de ganancias de hasta {pct} %",
      support: "¿Dudas antes de pagar? Escribe a {bot} en Telegram",
    },
    consentTitle: "Empezar de inmediato",
    couponHint: "Opcional. El descuento aparece en la página de pago.",
    consentFirst: "Marca la casilla de arriba para continuar.",
    network: "Red",
    consent: "Solicito que el servicio comience de inmediato. Entiendo que pierdo mi derecho de desistimiento una vez que se abre la cuenta del challenge.",
    subtotal: "Precio",
    discount: "Descuento",
    total: "Total",
    pay: "Continuar al pago",
    rules: "Reglas de esta versión",
    lead: "Revisa el programa, elige cómo pagar y confirma. La cuenta mantiene las reglas de esta versión hasta que termina.",
    size: "Tamaño de la cuenta",
    included: "Qué incluye",
    change: "Elegir otro programa",
  },
  steps: { program: "Programa", pay: "Pago", account: "Cuenta" },
  checkout: {
    title: "Pago",
    cardNumber: "Número de tarjeta",
    testCards: "Tarjetas de prueba: toca una para completarla",
    cardOk: "Aprobada",
    cardDeclined: "Rechazada",
    pay: "Pagar {total}",
    declined: "La tarjeta fue rechazada. Prueba con la tarjeta 4242.",
    paid: "Pagado. Tu cuenta se está abriendo.",
    opened: "Pagado. Tu cuenta está abierta.",
    opening: "Abriendo la cuenta…",
    toAccount: "Abrir la cuenta",
    sendExactly: "Envía exactamente {amount} {token} en {network} a:",
    expires: "La dirección caduca {at}.",
    waiting: "Esperando el depósito. Esta página se actualiza sola cuando se confirma.",
    sendTitle: "Pagar con USDT",
    review: "El pago está en revisión. La cuenta se abre en cuanto se confirma.",
    closed: "Este pedido ya no se puede pagar. Elige un programa para empezar uno nuevo.",
    notFound: "Pedido no encontrado.",
    copy: "Copiar",
    copied: "Copiado",
    lead: "Paga el pedido. La cuenta se abre en cuanto se confirma el pago.",
  },
  // ADR-0047: the live crypto payment screen.
  pay: {
    title: "Envía {token}",
    on: "en {network}",
    onlyNetwork: "Solo en {network}. Las monedas enviadas por otra red no llegan.",
    scan: "Escanea con tu billetera: la red, la dirección y el monto se completan solos",
    amount: "Monto",
    address: "Dirección",
    memo: "Comentario",
    memoNeed: "Agrega este comentario a la transferencia: nos indica qué pedido pagas.",
    exactly: "Envía exactamente este monto. Si tu exchange descuenta su comisión del monto, súmala aparte.",
    rate: "1 {coin} = {usd} · tasa fijada",
    timeLeft: "restante",
    windowClosed: "El plazo de pago terminó. Una transferencia que ya está en camino sigue contando; si no, empieza un pedido nuevo.",
    steps: { send: "Enviar", seen: "Detectada", confirm: "Confirmada", account: "Cuenta" },
    waiting: "Esperando tu transferencia…",
    seen: "Transferencia detectada · {n} de {m} confirmaciones",
    final: "Transferencia confirmada · abriendo la cuenta",
    underpaid: "Se recibieron {got}. Envía {amount} {token} más para completar; el monto de arriba ya está actualizado.",
    hashTitle: "¿Ya enviaste? Pega el hash de la transacción",
    hashLabel: "Hash de la transacción",
    hashCheck: "Verificar",
    hash: {
      credited: "Encontrada y acreditada a este pedido.",
      confirming: "Encontrada. Esperando que la red la confirme.",
      review: "No pudimos vincularla a este pedido automáticamente. Nuestro equipo la revisa y abre la cuenta si es tuya.",
    },
    errors: {
      tx_not_found: "Esta transacción no paga a nuestra dirección en esta red (todavía). Revisa la red y el hash.",
      tx_taken: "Esta transacción ya pagó otro pedido.",
      chain_unavailable: "La red no responde en este momento. Inténtalo de nuevo en un minuto; igual seguimos vigilando.",
      too_soon: "Una verificación cada pocos segundos, por favor.",
      rail_busy: "Esta moneda está ocupada en este momento. Elige otra red.",
      rate_unavailable: "No hay tasa en vivo para esta moneda en este momento. Elige otra.",
    },
    explorer: "Explorador",
    successTitle: "Tu cuenta está lista",
    successLead: "Pago confirmado. Opera el challenge con las reglas que viste.",
    tradeNow: "Operar ahora",
    toAccount: "Datos de la cuenta",
    copyAmount: "Copiar monto",
    copyAddress: "Copiar dirección",
  },
  orders: {
    title: "Pedidos",
    empty: "Aún no hay pedidos.",
    status: { awaiting_payment: "pendiente de pago", paid: "pagado", provisioned: "cuenta abierta", expired: "vencido", refunded: "reembolsado", chargeback: "contracargo", manual_review: "revisión manual", canceled: "cancelado" },
    invoice: "Factura {n}",
    launch: "precio de lanzamiento",
    lead: "Cada challenge que compraste, con su estado y su factura.",
    emptyLead: "Elige un programa para comprar tu primer challenge.",
    buyAnother: "Comprar otro",
    toPrograms: "Elegir un programa",
    pay: "Pagar",
    openAccount: "Cuenta",
  },
  kyc: {
    title: "Verificación de identidad",
    why: "Obligatoria antes de una cuenta funded y de cualquier payout.",
    country: "País del documento",
    countryHint: "Dos letras, p. ej. DE, GB, UZ",
    residence: "País de residencia",
    residenceHint: "Donde vives ahora, dos letras",
    region: "Región",
    regions: { other: "Otra región", ua43: "Crimea", ua40: "Sebastopol", ua14: "Región de Donetsk", ua09: "Región de Luhansk", ua23: "Región de Zaporiyia", ua65: "Región de Jersón" },
    number: "Número de documento",
    selfie: "Confirmo el paso de la selfie",
    lockedTitle: "La verificación se habilita con tu primer payout",
    lockedText: "Verificas tu identidad una sola vez, cuando hace falta: en cuanto una de tus cuentas aprueba su challenge o una cuenta funded llega a su primer payout. Hasta entonces no hay nada que hacer aquí.",
    lockedGo: "Tus cuentas",
    approvedNext: "Los payouts se habilitan en cuanto una cuenta funded cumple los requisitos.",
    pendingNote: "Revisamos las solicitudes en un día hábil. Esta página se actualiza sola.",
    submit: "Enviar",
    status: { started: "iniciada", pending: "en revisión", approved: "aprobada", rejected: "rechazada", retry: "inténtalo de nuevo" },
  },
  payouts: {
    title: "Payouts",
    wallets: "Billeteras",
    addWallet: "Agregar una billetera",
    chain: "Red",
    address: "Dirección",
    label: "Etiqueta",
    add: "Agregar",
    available: "utilizable desde {at}",
    walletStatus: { screening: "en revisión", active: "activa", blocked: "bloqueada por la revisión de sanciones", removed: "eliminada" },
    remove: "Eliminar",
    removeConfirm: "¿Eliminar definitivamente?",
    keep: "Conservar",
    noWallets: "Aún no hay billeteras. Agrega la dirección a la que llegarán tus payouts.",
    addressHint: "Pega la dirección; la red se detecta a partir de ella.",
    addressWrong: "Esto no parece una dirección de {chain}.",
    walletAdded: "Billetera agregada. Primero se revisa y luego se puede usar tras el plazo de espera para direcciones nuevas.",
    sendTo: "Enviar a",
    needWallet: "Agrega una billetera para solicitar este payout.",
    sent: "Payout solicitado. Su estado aparece en el historial de abajo.",
    steps: {
      title: "Tu primer payout en cuatro pasos",
      funded: "Obtén una cuenta funded",
      fundedNote: "Aprueba el challenge; la cuenta funded se abre cuando aceptas su acuerdo.",
      fundedGo: "Tus cuentas",
      kyc: "Verifica tu identidad",
      kycNote: "Obligatoria antes de cualquier payout.",
      kycGo: "Verificar ahora",
      wallet: "Agrega una billetera",
      walletNote: "Una dirección de TRON o Ethereum para USDT.",
      walletGo: "Agregar una billetera",
      request: "Solicita el payout",
      requestNote: "Cuando una cuenta cumple los requisitos, su monto aparece arriba con el botón de solicitud.",
    },
    account: "Cuenta funded",
    noFunded: "Los payouts se habilitan en una cuenta funded.",
    profit: "Ganancia",
    split: "Tu reparto",
    amount: "Recibes",
    eligible: "Disponible",
    request: "Solicitar un payout",
    next: "Próxima fecha posible {at}",
    microDetail: "El {share} % de la ganancia desde el último payout viene de operaciones mantenidas menos de {sec} s; el límite es {max} %.",
    streakDetail: "Hasta ahora, {best} de {days} días con ganancia seguidos; cada día necesita al menos {bar}.",
    reasons: {
      no_rules: "Este programa no tiene payouts",
      kyc: "Verifica tu identidad",
      wallet: "Agrega una billetera y espera el plazo para direcciones nuevas",
      open_positions: "Cierra tus posiciones",
      first_payout_delay: "Aún es pronto para el primer payout",
      cycle: "El ciclo de payout no ha terminado",
      below_minimum: "Ganancia por debajo del mínimo",
      profitable_days: "No hay suficientes días con ganancia",
      consistency: "Un solo día es una parte demasiado grande de la ganancia",
      profitable_streak: "No hay suficientes días con ganancia seguidos",
      micro_scalping: "Demasiada ganancia viene de micro-scalps",
      min_trades: "No hay suficientes operaciones cerradas",
      best_trade: "Una sola operación es una parte demasiado grande de la ganancia",
      max_payouts: "Esta cuenta ya recibió su payout",
      window_open: "La sesión sigue en curso: el payout se habilita cuando termina su reloj",
      window_missed: "El objetivo no se alcanzó antes de que se acabara el reloj",
      below_fee: "La comisión de procesamiento se llevaría todo el monto",
    },
    history: "Historial",
    status: { requested: "solicitado", prepared: "pendiente de aprobación", paid: "pagado", rejected: "rechazado", failed: "fallido" },
    agreement: "Acuerdo de trader funded",
    agreementText: "Acepta el acuerdo de trader funded para abrir la cuenta.",
    accept: "Aceptar y abrir la cuenta funded",
    lead: "Tu parte de la ganancia en cuentas funded: mira qué falta, elige una billetera y solicítala.",
    availableNow: "Disponible para solicitar ahora",
    cap: "Tope de este payout",
    capNote: "tu parte está limitada a este tope; los bonos de abajo se suman aparte",
    feeRefund: "Reembolso de la comisión",
    performanceReward: "Premio por rendimiento",
    haircut: "Penalización por reinicio −{pct} %",
    haircutNote: "la cuenta se reinició tras infringir una regla: cada payout se paga un {pct} % menos, de forma permanente",
    fee: "Comisión de procesamiento",
    feeCell: "{base} + {pct} %",
    feeNote: "payout en cripto; se descuenta antes del envío",
    feeReduced: "la mayoría de tus pedidos se pagaron en cripto: 2.49 % en lugar de 30 %",
    net: "Recibes",
    remainderSegment: "La ganancia por encima del tope se queda en la cuenta; el siguiente payout cuenta la nueva ganancia desde ahí.",
    remainderCarry: "La ganancia por encima del tope se queda en la cuenta y se puede retirar con un payout posterior.",
    resetNext: "Este es el payout #{n}: después, el balance vuelve al inicial y se eliminan los topes.",
    resetAt: "Después del payout #{n}, el balance vuelve al inicial y luego se eliminan los topes.",
    funding: "Capital funded",
    fundingCell: "{funded} de {cap}",
    fundingNote: "el máximo que un trader puede tener en cuentas funded, sumando todos los programas",
  },
  affiliate: {
    title: "Afiliados",
    code: "Tu código",
    link: "Tu enlace",
    rate: "Comisión {pct} %, disponible después de {days} días",
    referrals: "Traders referidos",
    commissions: "Comisiones",
    none: "Aún no eres afiliado.",
    status: { held: "retenida", available: "disponible", void: "anulada" },
    lead: "Comparte tu enlace. Los traders que se registran con él se cuentan aquí, y las comisiones se liberan después de la retención.",
  },
  admin: {
    tabs: { payments: "Pagos", payouts: "Payouts", kyc: "KYC", coupons: "Cupones", affiliates: "Afiliados", finance: "Finanzas" },
    order: "Pedido",
    customer: "Cliente",
    amount: "Monto",
    status: "Estado",
    approvePaid: "Confirmar pago",
    refund: "Reembolsar",
    chargeback: "Registrar un contracargo",
    reason: "Motivo",
    confirmDeposit: "Registrar un depósito",
    received: "Recibido",
    confirmations: "Confirmaciones",
    txHash: "Hash de la transacción",
    record: "Registrar",
    prepare: "Preparar",
    approve: "Aprobar y enviar",
    reject: "Rechazar",
    rejectViolation: "Rechazar: infracción de reglas",
    preparedBy: "preparado por {who}",
    ownPrepared: "Lo preparaste tú: lo envía otro aprobador",
    hedging: "{n} posiciones opuestas con cuentas vinculadas en 90 días: revisa Juego limpio antes de aprobar",
    acceptLate: "Aceptar el depósito tardío",
    rail: "Canal",
    attach: "Vincular una transacción",
    attachHint: "Se lee de la cadena y se verifica como cualquier pago",
    transfers: "Transferencias",
    unmatched: "Transferencias que ningún pedido tomó",
    unmatchedNone: "Ninguna en los últimos 30 días.",
    claimed: "el comprador reclamó el pedido {id}",
    attachResult: "Resultado: {result}",
    decide: { approved: "Aprobar", rejected: "Rechazar", retry: "Pedir que lo intente de nuevo" },
    duplicate: "Mismo documento que {email}",
    newCoupon: "Nuevo cupón",
    code: "Código",
    kind: "Tipo",
    value: "Valor",
    maxRedemptions: "Usos máx.",
    used: "Usados",
    create: "Crear",
    newUsersOnly: "Solo usuarios nuevos",
    turnOff: "Desactivar",
    turnOn: "Activar",
    off: "desactivado",
    reconciliation: "Conciliación",
    providerNet: "Neto del proveedor",
    ledgerCash: "Efectivo en el libro",
    difference: "Diferencia",
    unbalanced: "Transferencias del libro descuadradas: {n}",
    report: "Ratio de payouts por cohorte",
    cohort: "Cohorte",
    sales: "Ventas",
    revenue: "Ingresos",
    paid: "Payouts",
    ratio: "Ratio",
    signal: "Por encima del 55 %: revisa precios y reglas",
    beta: "Beta testers: embudo para precios",
    betaNote: "p_f — llegaron a funded · q — funded con un payout pagado · s — parte pagada promedio del tamaño de la cuenta · p_f×q×s — payout esperado por cada $1 de tamaño de cuenta que el precio debe cubrir.",
    challenges: "Challenges",
    funded: "Funded",
    market: "Mercado",
    newAffiliate: "Hacer afiliado a un usuario",
    email: "Correo electrónico",
  },
  // ADR-0035: a bonus of a purchase (extra account, free reset) is used once its activation fee is paid.
  bonus: {
    lockedFee: "Luego se activa por {fee}.",
    available: "Listo. Paga la tarifa de activación y la cuenta se abre.",
    availableFree: "Listo. Actívalo y la cuenta se abre.",
    activate: "Activar por {fee}",
    activateFree: "Activar",
    confirmExtra: "¿Pagar {fee} y abrir ahora la cuenta extra #{n}?",
    confirmReset: "El reinicio es gratis, pero hay que activarlo: {fee}. ¿Pagar y reiniciar el challenge ahora?",
    confirmResetFree: "¿Reiniciar ahora el challenge desde su balance inicial?",
    pay: "Pagar {fee}",
    go: "Reiniciar",
    cancel: "Cancelar",
    resetReadyFee: "El challenge terminó. Reinícialo desde el balance inicial con las mismas reglas. Tarifa de activación: {fee}.",
    resetUse: "Usar el reinicio · {fee}",
  },
} satisfies Messages<typeof en>;
